// Module
var code = "<div v-if=\"isThankYouPage && product.fulfillment.isDelivered && product.thankYouPageText\"> <cProductInstructions :is-thank-you-page=\"isThankYouPage\" :product=\"product\"/> </div> ";
// Exports
export default code;